module.exports = __webpack_public_path__ + "img/book.0c1dbbf1.svg";